import SearchIcon from '@material-ui/icons/Search';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import UpdateIcon from '@material-ui/icons/Update';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SettingsIcon from '@material-ui/icons/Settings';
import LockIcon from '@material-ui/icons/Lock';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

/**
 * Get nav items based on the logged in user.
 * 
 * @param {*} authDealer 
 * 
 * @returns array
 */
export const getNavItems = (authDealer, paths) => {
  if (!authDealer) {
    return [];
  }

  // console.log('authDealer', authDealer);

  const items = [];

  items.push({ icon: <DashboardIcon />, title: 'Dashboard', route: '/' });

  items.push({ icon: <ShoppingCartIcon />, key: 'orders', title: 'Your Orders', route: '/content/orders' });

  items.push({ icon: <NotListedLocationIcon />, key: 'subs-curr-status', title: 'Subscription Status', route: '/subscription/current-status' });
  items.push({ icon: <UpdateIcon />, key: 'payments', title: 'Payments History', route: '/subscription/payments' });

  items.push({ icon: <SettingsIcon />, title: 'RMA Configurations', route: '/user/rma-configs' });
  items.push({ icon: <AccountBoxIcon />, title: 'Update Profile', route: '/user/update-profile' });
  items.push({ icon: <LockIcon />, title: 'Change Password', route: '/user/change-password' });
  items.push({ icon: <ExitToAppIcon />, title: 'Logout', route: '/user/logout' });

  return items;
};

/**
 * Get logged in user links.
 * 
 * @returns array
 */
export const getUserLinks = () => {
  return [
    { icon: <AccountBoxIcon />, title: 'Update Profile', route: '/user/update-profile' },
    { icon: <LockIcon />, title: 'Change Password', route: '/user/change-password' },
    { icon: <ExitToAppIcon />, title: 'Logout', route: '/user/logout' },
  ];
};
